import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];
const LINE = "M8 150 L40 132 L72 140 L104 104 L136 112 L168 74 L200 82 L232 44";
const AREA = LINE + " L232 170 L8 170 Z";

/**
 * Animated, on-theme upward growth chart used as a background accent.
 * The line draws itself in, an arrow appears at the tip, and a glowing dot
 * travels smoothly upward along the curve on a loop.
 */
export const GrowthChart = ({ className = "" }) => {
  return (
    <svg viewBox="0 0 240 178" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="gc-line" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="hsl(25 100% 50%)" />
          <stop offset="100%" stopColor="hsl(29 100% 63%)" />
        </linearGradient>
        <linearGradient id="gc-area" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="hsl(25 100% 50%)" stopOpacity="0.3" />
          <stop offset="100%" stopColor="hsl(25 100% 50%)" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Soft area fill */}
      <motion.path
        d={AREA}
        fill="url(#gc-area)"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, delay: 0.6, ease }}
      />

      {/* Growth line drawing in */}
      <motion.path
        d={LINE}
        stroke="url(#gc-line)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease }}
      />

      {/* Arrow head at the tip (pointing up-right) */}
      <motion.path
        d="M232 44 L218 42 M232 44 L230 58"
        stroke="url(#gc-line)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: 1.55, ease }}
      />

      {/* Travelling glow + dot */}
      <circle r="9" fill="hsl(29 100% 63%)" opacity="0.22">
        <animateMotion dur="3.4s" repeatCount="indefinite" calcMode="linear" path={LINE} />
      </circle>
      <circle r="4.5" fill="hsl(29 100% 63%)">
        <animateMotion dur="3.4s" repeatCount="indefinite" calcMode="linear" path={LINE} />
      </circle>
    </svg>
  );
};
